import { domain } from 'modules/data';
import { useMemo } from 'react';

import { MappedBudget } from '../../hooks/useBudgets';
import { useGetTrackingFields } from '../../hooks/useGetTrackingFields';
import { getTrackingStaticItems } from './TrackingCategoriesFormPart.helpers';

export const useCutsetValuesFromBudget = (
    budget: MappedBudget,
    fieldsData: ReturnType<typeof useGetTrackingFields>['data']
) => {
    return useMemo(() => {
        if (!fieldsData) return [];

        let fields: domain.BudgetTrackingCutset[] = [];

        budget.constraints.forEach(({ value, fieldId, fieldName }) => {
            const defaultFieldConstraint = getTrackingStaticItems(fieldId, fieldName)[0];
            const fieldIndex = fieldsData.findIndex((field) => field.fieldId === fieldId);

            fields[fieldIndex] = {
                fieldId,
                exactConstraintId: value?.id || defaultFieldConstraint.exactConstraintId,
                exactConstraintValue: value?.text || defaultFieldConstraint.exactConstraintValue,
            };
        });

        return fields;
    }, [budget.constraints, fieldsData]);
};
